import styled from 'styled-components';
import {interceptProps} from '@/styled-components';
import {Marker} from '../../Overlay';
import Icon from './pov-panorama-marker.svg';

interface IProps {
  map: naver.maps.Map;
  position?: naver.maps.LatLng;
  rotate: number;
}

export const PovMarker = ({map, position, rotate = 0}: IProps) => {
  if (!position) {
    return null;
  }

  return (
    <Marker map={map} position={position} draggable={false} clickable={false}>
      <Point>
        <Root>
          <Content rotate={rotate} />
        </Root>
      </Point>
    </Marker>
  );
};

const Root = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(calc(-50% + 1.5px), calc(-50% + 2px));
`;

const Point = styled.div`
  position: relative;
  top: 0;
  left: 0;
`;

const Content = styled('div').withConfig({
  shouldForwardProp: interceptProps(['rotate']),
})<{
  rotate: number;
}>`
  width: 34px;
  height: 34px;
  background-image: url(${Icon});
  background-position: center top;
  background-repeat: no-repeat;
  transform: rotate(${({rotate = 0}) => rotate}deg);
`;
